export function ComingSoon({ title, note }: { title: string; note: string }) {
  return (
    <section className="rounded-xl border border-border bg-bg-elevated p-6">
      <h1 className="font-display text-xl font-semibold text-text">{title}</h1>
      <p className="mt-2 max-w-prose text-sm text-text-muted">{note}</p>
      <p className="mt-4 inline-flex rounded-full bg-bg-elevated-hover px-3 py-1 font-display text-xs font-semibold uppercase tracking-wider text-text-faint">
        Coming soon
      </p>
    </section>
  );
}
